// extracted by mini-css-extract-plugin
var _1 = "UiControls__UiControls___JY5xo";
var _2 = "UiControls__disabled___LPXcW";
var _3 = "UiControls__group___JFZyh";
var _4 = "UiControls__hr___D5CaN";
var _5 = "UiControls__icon___w9_MP";
var _6 = "UiControls__right___oru13";
var _7 = "UiControls__wiggle___bRET8";
export { _1 as "UiControls", _2 as "disabled", _3 as "group", _4 as "hr", _5 as "icon", _6 as "right", _7 as "wiggle" }
